import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { parse, isDate } from 'date-fns';
import br from 'date-fns/locale/pt-BR';
import './styles.css';
import { mdiCalendar } from '@mdi/js';
import { ValidateError } from '../ErrorMessage';
import Icons from '../Icon';

export const Datepicker = ({
  label = '',
  value,
  min,
  max,
  onChange,
  datePickerClassName = '',
  form,
  disabled,
  field,
  showYearDropdown,
  yearDropdownItemNumber,
  scrollableYearDropdown,
}) => {
  const [selected, setSelect] = useState(0);

  useEffect(() => {
    const isValidDate = isDate(field?.value || value);
    const formattedDate =
      !isValidDate && field?.value
        ? parse(field?.value, 'dd/MM/yyyy', new Date(), {
            locale: br,
          })
        : field?.value || value;

    if (disabled) {
      if (field?.value || value) {
        setSelect(field?.value ? formattedDate : value);
      } else {
        setSelect(0);
      }
    } else {
      setSelect(formattedDate);
    }
  }, [disabled, field, value]);

  return (
    <>
      <label className={`label ${disabled && 'disabled'}`} htmlFor="datepicker">
        {label}
      </label>
      <div className="position-relative">
        <DatePicker
          disabled={disabled}
          locale="pt"
          dateFormat="dd/MM/yyyy"
          minDate={min}
          maxDate={max}
          selected={selected}
          onChange={(date) => {
            if (form) {
              return form.setFieldValue(field.name, date);
            }
            return onChange(date);
          }}
          onBlur={() => form.setFieldTouched(field.name)}
          className={datePickerClassName}
          id="datepicker"
          showYearDropdown={showYearDropdown}
          yearDropdownItemNumber={yearDropdownItemNumber}
          scrollableYearDropdown={scrollableYearDropdown}
        />
        <Icons
          path={mdiCalendar}
          style={{
            position: 'absolute',
            top: 10,
            right: 12,
            pointerEvents: 'none',
          }}
        />
        {form && form.touched[field.name] && form.errors[field.name] && (
          <ValidateError>{form.errors[field.name]}</ValidateError>
        )}
      </div>
    </>
  );
};
